// Backend persistence for the Reports page layout. The layout (ordered list of
// selected widgets + report meta) is stored per user in DynamoDB via the
// `/users/:userId/report-layout` endpoints, so it follows the user across
// devices and browsers.

import axios from "axios";

/**
 * Fetch the saved layout for a user. Returns null when nothing is saved.
 * Reads are unauthenticated (mirrors GET /users/:userId), but auth headers are
 * passed when available.
 */
export async function fetchReportLayout({ apiBase, userId, headers }) {
  if (!apiBase || !userId) return null;
  const resp = await axios.get(`${apiBase}/users/${userId}/report-layout`, {
    headers: headers || {},
  });
  const layout = resp?.data?.layout;
  if (!layout || typeof layout !== "object") return null;
  return {
    widgets: Array.isArray(layout.widgets) ? layout.widgets : [],
    presetId: typeof layout.presetId === "string" ? layout.presetId : null,
    reportTitle: typeof layout.reportTitle === "string" ? layout.reportTitle : null,
    subtitle: typeof layout.subtitle === "string" ? layout.subtitle : null,
  };
}

/**
 * Persist the layout for a user. `widgets` should be the ordered `placed`
 * array; only catalogId/channel/size are sent. Requires a valid auth token.
 */
export async function saveReportLayout({ apiBase, userId, headers, widgets, presetId, reportTitle, subtitle }) {
  if (!apiBase || !userId) return;
  const layout = {
    presetId: presetId ?? "",
    reportTitle: reportTitle ?? "",
    subtitle: subtitle ?? "",
    widgets: (widgets || []).map((w) => ({
      catalogId: w.catalogId,
      channel: w.channel,
      size: w.size,
    })),
  };
  await axios.put(
    `${apiBase}/users/${userId}/report-layout`,
    { layout },
    { headers: headers || {} }
  );
}
